import { render } from "./RetailerInventory.vue?vue&type=template&id=5b532b01"
import script from "./RetailerInventory.vue?vue&type=script&lang=js"
export * from "./RetailerInventory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__